module.exports = __webpack_public_path__ + "static/media/pricing3.2174d3ec.jpg";